<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->

    <!-- <b-navbar toggleable type="inverse" variant="inverse" fixed="top">  -->
    <b-navbar toggleable variant="faded">

      <b-nav-toggle target="nav_collapse"></b-nav-toggle>

      <b-link class="navbar-brand" to="/">
        <img src="/static/favicon.ico" width="30" height="30" classs="d-inline-block align-top" alt="">
        <!-- <icon name="question-circle" class="text-success" scale="1"></icon> -->
        <span>Koonys Quizzes <span id="beta">Beta</span></span>
      </b-link>

      <b-collapse is-nav id="nav_collapse">

        <b-nav is-nav-bar>
          <b-nav-item to="/">Startseite</b-nav-item>
        </b-nav>

        <b-nav is-nav-bar class="ml-auto">


          <!-- <b-nav-item href="#" onclick="_urq.push(['Feedback_Open'])">Feedback</b-nav-item> -->
          <!-- <li class="nav-item"><a href="#" class="nav-link" onclick="_urq.push(['Feedback_Open'])">Feedback</a></li> -->

          <b-nav-item to="/login" v-if="user.isAnonymous">Login</b-nav-item>

          <b-nav-item-dropdown :right="true" :caret="false" v-else class="img-profile">

            <!-- Using text slot -->
            <template slot="text">
              <!-- <span style="font-weight: bold;" :title="user.displayName">adsf</span> -->
              <img :src="user.photoURL" :title="user.displayName" class="hidden-sm-down" />
              <span class="hidden-md-up">Account</span>
            </template>
            <b-dropdown-header>{{user.displayName}}</b-dropdown-header>
            <!-- <b-dropdown-item v-if="$store.state.user.uid == 'Ag71aaRbPaPyvMTz3MkXvys9B7d2'" to="/user/quizzes"><i class="fa fa-user fa-fw"></i> Deine Quizzes</b-dropdown-item> -->
            <!-- <b-dropdown-item v-if="$store.state.user.isAdmin" to="/user/quizzes"><i class="fa fa-user fa-fw"></i> Deine Quizzes</b-dropdown-item> -->
            <b-dropdown-item to="/user/quizzes"><i class="fa fa-user fa-fw"></i> Deine Quizzes</b-dropdown-item>
            <!-- <router-link to="/user/quizzes">Go to Foo</router-link> -->
            <b-dropdown-item @click="logout"><i class="fa fa-sign-out fa-fw"></i> Signout</b-dropdown-item>
          </b-nav-item-dropdown>

        </b-nav>
      </b-collapse>
    </b-navbar>

    <!-- <div class="container-fluid"> -->

    <router-view v-if="user.uid !==  null"></router-view>
    <div v-else><!-- nothing --></div>

    <!-- </div> -->

    <div id="footer" class="container">
      <div class="row">
        <div class="col"><hr /></div>
      </div>
      <div class="row mb-3">
        <div class="col"><small><a href="http://www.koonys.de" target="_blank" class="text-muted"><i class="fa fa-copyright fa-fw"></i> Koonys Schule</a></small></div>
        <!-- <div class="col"></div> -->
        <div class="col text-right"><b-button variant="link" size="sm" onclick="_urq.push(['Feedback_Open'])">Feedback</b-button></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
        // user: null
      }
    },
    metaInfo(){
      return {
        title: 'Startseite',
        titleTemplate: 'Koonys Quizzes | %s',
        meta: [
        {name: 'keywords', content: 'Aufgaben online, online testen, mathematik online, quiz online, online lernen, mathe online, lösungen online, aufgaben online testen'}
        ]
      }
    },
    methods: {
      logout(){
        console.log('Logge out.', this.$router)

        this.$store.dispatch('logout')
        this.$router.push('/')
      }
    },
    computed: {
      // ...mapState(['user'])
      user() {
        // console.log('store user name: ', this.$store.state.user && this.$store.state.user.displayName)
        // console.log('store user name: ', this.$store.state.user && this.$store.state.user)
        
        return this.$store.state.user
      }
    },
    beforeMount() {
      console.log('before app mounted');
    },
    mounted() {
      console.log('app mounted');
    }
  }
</script>

<style>
  li.img-profile > a:first-child{
    padding: 0px;
  }

  li.img-profile a img{
    height: 40px;
    border-radius: 20px;
  }

  body{
    overflow-y: scroll
  }

  #beta{
    vertical-align: top;
    font-size: 69%;
    font-style: italic;
    opacity: 0.69;
  }
</style>



// WEBPACK FOOTER //
// App.vue?309ea680